import ReactGA from "react-ga4";

export const initGA = () => {
  // Same ID as putforshare.com
  ReactGA.initialize("G-PP4WS0D0RX", {
    gtagOptions: {
      linker: {
        domains: ["putforshare.com", "dash.putforshare.com"],
        accept_incoming: true,
      },
    },
  });
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};
